var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"jumbotron"},[_c('h3',[_vm._v("5meter Dispo-Tool")])])
}]

export { render, staticRenderFns }